import { Pagination, Popconfirm, Table, Tag, Tooltip } from "antd";
import { AiOutlineDelete } from "react-icons/ai";
import { CiEdit, CiRead } from "react-icons/ci";

function OffersDataTable(props: any) {
  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
      render: (_: any, __: any, rowIndex: number) => {
        return <div className="table-Txt">{rowIndex + 1}</div>;
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (record: any) => {
        return <div className="table-Txt">{record}</div>;
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (record: any) => {
        return <div className="table-Txt">{record}</div>;
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (record: any) => {
        return <div className="table-Txt">{record}</div>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (record: any) => {
        return (
          <div className="table-Txt">
            {record ? (
              <Tag color="green">Active</Tag>
            ) : (
              <Tag color="green">Inactive</Tag>
            )}
          </div>
        );
      },
    },
    {
      title: "Publish",
      dataIndex: "publish",
      key: "publish",
      render: (record: any) => {
        return (
          <div className="table-Txt">
            {record ? (
              <Tag color="green">Published</Tag>
            ) : (
              <Tag color="red">Unpublished</Tag>
            )}
          </div>
        );
      },
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (record: any) => {
        return (
          <img
            src={record}
            alt="example"
            style={{ width: 50, height: 50, objectFit: "contain" }}
            className="table-Txt"
          />
        );
      },
    },
    {
      title: "Action",
      with: 10,
      render: (item: any) => (
        <div
          className="table-item"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* <div>
            <Tooltip title="View" mouseEnterDelay={0.5} color="#8f8e8d">
              <CiRead
                size={20}
                style={{ cursor: "pointer", color: "blue" }}
                onClick={() => props?.onView(item?.id)}
              />
            </Tooltip>
          </div> */}
          <div>
            <Tooltip title="Edit" mouseEnterDelay={0.5} color="#8f8e8d">
              <CiEdit
                size={20}
                onClick={() => props?.onEdit(item)}
                style={{ cursor: "pointer", color: "orange" }}
              />
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Delete" mouseEnterDelay={0.5} color="#8f8e8d">
              <Popconfirm
                title="Delete the Offers's Details"
                description="Are you sure you want to delete the Offers Details?"
                onConfirm={() => props?.delete(item?.id)}
                okText="Yes"
              >
                <AiOutlineDelete
                  size={20}
                  style={{ color: "red", cursor: "pointer" }}
                />
              </Popconfirm>
            </Tooltip>
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table
        columns={columns}
        dataSource={props?.data}
        pagination={false}
        size="small"
      />
      <br />
      <br />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Pagination
          total={props?.meta?.total_count}
          showSizeChanger
          showTotal={(total) => `Total ${props?.meta?.total_count} Offers`}
          onChange={(page, pageSize) => props.onPageChange(page, pageSize)}
        />
      </div>
    </div>
  );
}
export default OffersDataTable;
